var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import * as Modal from "react-modal";
import { MoodboardSelectionModal } from "./MoodboardSelectionModal";
import { render } from "react-dom";
import { useEffect, useState } from "react";
import { fetchApi, getLang, translate } from "@js/common/helpers";
import { HttpMethods } from "tagwalk-api-client/assets/js/common/enums";
import { createOrShowMoodboardPaywall } from "@js/common/moodboardPaywall";
export var QuicksaveOverlay = function (_a) {
    var dataLookSlug = _a.dataLookSlug, visibilityCallbackObj = _a.visibilityCallbackObj;
    var serializedMoodboard = localStorage.getItem('selected_moodboard');
    var moodboard = serializedMoodboard ? JSON.parse(serializedMoodboard) : null;
    var _b = useState(false), visibility = _b[0], setVisibility = _b[1];
    useEffect(function () {
        var timeoutId = null;
        visibilityCallbackObj.callback = function (value) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            if (value) {
                timeoutId = window.setTimeout(function () {
                    setVisibility(value);
                    timeoutId = null;
                }, 50);
            }
            else {
                setVisibility(value);
            }
        };
    }, []);
    var _c = useState(false), saved = _c[0], setSaved = _c[1];
    useEffect(function () {
        setSaved(false);
    }, [serializedMoodboard]);
    function initSelectionModal() {
        return __awaiter(this, void 0, void 0, function () {
            var body, newNode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, createOrShowMoodboardPaywall()];
                    case 1:
                        if (_a.sent()) {
                            return [2];
                        }
                        body = document.querySelector('body');
                        Modal.setAppElement(body);
                        newNode = document.createElement("div");
                        body.append(newNode);
                        render(React.createElement(MoodboardSelectionModal, null), newNode);
                        return [2];
                }
            });
        });
    }
    function save() {
        return __awaiter(this, void 0, void 0, function () {
            var lang, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!moodboard) {
                            return [2];
                        }
                        return [4, createOrShowMoodboardPaywall()];
                    case 1:
                        if (_a.sent()) {
                            return [2];
                        }
                        lang = getLang();
                        return [4, fetchApi("moodboards_add_look." + lang, HttpMethods.put, {
                                'slug': moodboard.slug,
                                'type': 'media',
                                'lookSlug': dataLookSlug,
                            }, null, false, {
                                'X-Requested-With': 'XMLHttpRequest',
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            setSaved(true);
                        }
                        return [2];
                }
            });
        });
    }
    if (!visibility) {
        return (React.createElement("div", { className: "moodboard-overlay-disabled" }));
    }
    return (React.createElement("div", { className: "moodboard-overlay flex" },
        React.createElement("div", { className: "moodboard-overlay-name", onClick: initSelectionModal, title: moodboard ? moodboard.name : '' }, moodboard ? moodboard.name : translate('moodboard_quicksave.select')),
        React.createElement("div", { className: "moodboard-overlay-caret-container", onClick: initSelectionModal },
            React.createElement("i", { className: "iconoir-nav-arrow-down ms-2" })),
        React.createElement("div", { className: "moodboard-overlay-btn-container" },
            (moodboard && !saved) &&
                React.createElement("div", { className: "btn-bg-black-color-white", onClick: save },
                    React.createElement("i", { className: "iconoir-bookmark" })),
            (moodboard && saved) &&
                React.createElement("div", { className: "btn-bg-black-color-white" },
                    React.createElement("i", { className: "iconoir-bookmark-solid" })))));
};
